import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface AISummaryCardProps {
  summary: string;
  className?: string;
}
export function AISummaryCard({
  summary,
  className = ''
}: AISummaryCardProps) {
  const {
    isLight
  } = useTheme();
  return <div className={`backdrop-blur-xl border rounded-2xl p-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 shadow-sm' : 'bg-dark-card/80 border-white/10 shadow-lg'} ${className}`} data-id="element-581" data-mp="5jl0pa7fjdgd">
      <div className="flex items-center gap-2 mb-3" data-id="element-582" data-mp="390teniz1dt5t">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center border ${isLight ? 'bg-vexu/10 border-vexu/20' : 'bg-vexu/10 border-vexu/20'}`} data-id="element-583" data-mp="3dyuy450djuht">
          <Sparkles className={`w-4 h-4 ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-584" data-mp="3iro2grrxl0td" />
        </div>
        <span className={`text-xs font-bold uppercase tracking-wider ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-585" data-mp="2q9adzishir6y">
          AI Summary
        </span>
      </div>
      <p className={`text-sm leading-relaxed ${isLight ? 'text-slate-600' : 'text-zinc-300'}`} data-id="element-586" data-mp="95qmeq09dyhc">
        {summary}
      </p>
    </div>;
}